export const fileQueries = {
    importReportCounts: {
        addCount: true,
        limit: 0,
        initialFilter: null,
    },
};

export const caseQueries = {
    casesReportCounts: {
        addCount: true,
        limit: 0,
        text: '',
        initialFilter: {},
        where: {},
    },
};
